import { render, staticRenderFns } from "./AppointmentSlotOverview.vue?vue&type=template&id=1ec8c589"
import script from "./AppointmentSlotOverview.vue?vue&type=script&lang=js"
export * from "./AppointmentSlotOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports